import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>Created by TunjiDev</p>
    </footer>
  );
}

export default Footer;
